import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuditDetailsView from "./AuditDetailsView";
import AuditUpdateView from "./AuditUpdateView";
// Import the function to clear loading state
import { updateLoadingState } from "../../../api/FetchAuditList";

export default function AuditDetailsInlineView({
  audit,
  onClose,
  onUpdateSuccess,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const navigate = useNavigate();

  const handleEdit = () => {
    setIsEditing(true);
    setIsFullScreen(true); // Open in full screen when editing
  };

  const handleExpand = () => {
    setIsFullScreen(true);
  };

  const handleUpdateClose = () => {
    setIsEditing(false);
    setIsFullScreen(false); // Exit full screen when closing edit mode
  };

  const modalStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    //bgcolor: "background.paper",
    boxShadow: 24,
    p: 2, // Reduced padding
    borderRadius: 0, // Removed border radius for full screen
    overflow: "auto", // Changed to auto for better scroll handling
    display: "flex",
    flexDirection: "column",
  };

  if (!audit) return null;

  // If in full screen mode, render in a modal
  if (isFullScreen) {
    return (
      <Modal
        open={true}
        onClose={
          () => (isEditing ? null : setIsFullScreen(false)) // Prevent closing modal when editing
        }
        aria-labelledby="audit-details-modal"
        aria-describedby="full-screen-audit-details-or-edit"
      >
        <Box sx={modalStyle}>
          {isEditing ? (
            <AuditUpdateView
              audit={audit}
              onClose={handleUpdateClose}
              onUpdateSuccess={() => {
                onUpdateSuccess();
                setIsEditing(false);
                setIsFullScreen(false);
              }}
              isFullScreen={true}
              allAudits={audit ? [audit] : []} // Pass current audit for drag and drop
            />
          ) : (
            <AuditDetailsView
              audit={audit}
              onClose={() => setIsFullScreen(false)}
              onEdit={handleEdit}
              onExpand={handleExpand}
              isFullScreen={true}
            />
          )}
        </Box>
      </Modal>
    );
  }

  // Standard view (not full screen)
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={1} // Reduced gap
      sx={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
        padding: 0, // Added explicit padding of 0
      }}
    >
      {isEditing ? (
        <AuditUpdateView
          audit={audit}
          onClose={handleUpdateClose}
          onUpdateSuccess={() => {
            onUpdateSuccess();
            setIsEditing(false);
          }}
          allAudits={audit ? [audit] : []} // Pass current audit for drag and drop
        />
      ) : (
        <AuditDetailsView
          audit={audit}
          onClose={onClose}
          onEdit={handleEdit}
          onExpand={handleExpand}
        />
      )}
    </Box>
  );
}
